import React from "react";
import styled from "styled-components";
import Spinner from "sushiweb/Spinner";

const ScreenLoader = () => {
  return (
    <ScreenLoaderContainer>
      <Spinner />
    </ScreenLoaderContainer>
  );
};

export default ScreenLoader;

const ScreenLoaderContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
